import { PageComponent } from "components/page";
import { getMappings } from "pages/getPageTemplatesMappings";
import React, { useEffect, useState } from "react";
import { translate } from "reducers/i18n";
import { connect } from "react-redux";

const LandingPage = (props) => {
  const [messageId, setMessageId] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentHandlebars, setCurrentHandlebars] = useState({});
  const [placeholder, setPlaceholder] = useState("");

  useEffect(() => {
    setLoading(true);
    getMappings("landingPage", props.match.params.tenantId)
      .then((mappings) => {
        setCurrentHandlebars(mappings["E_DELIVERY_LANDING_PAGE"]);
        setPlaceholder(
          mappings["E_DELIVERY_LANDING_PAGE"]?.placeholder?.replace(
            /<\/?[^>]+(>|$)/g,
            ""
          ) || ""
        );
      })
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));
  }, [props.language]);

  const handleMessageRequest = () => {
    setLoading(true);
    if (messageId) {
      props.history.push(`/edelivery/${props.match.params.tenantId}/login/${messageId}`);
    }
    setLoading(false);
  };

  return (
    <div className="loginForm panel">
      {loading && <p>{translate("_isLoading")}...</p>}
      <PageComponent
        content={currentHandlebars}
        btnFunctions={[handleMessageRequest]}
        disabled={!messageId}
      >
        <p>
          <input
            className="code"
            autoFocus={true}
            type="text"
            inputMode="numeric"
            enterkeyhint={translate("_submit")}
            key="code"
            placeholder={placeholder}
            onChange={(e) => setMessageId(e.target.value)}
            onKeyPress={(e) => {
              if (!loading && e.key === "Enter") handleMessageRequest();
            }}
          />
        </p>
      </PageComponent>
    </div>
  );
};

// Map Redux state to props
const mapStateToProps = (state) => ({
  language: state.i18n.language, // Map the language from the i18n reducer
});

// Connect the component to the Redux store
export default connect(mapStateToProps)(LandingPage);
